import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home';
import JewelryDetails from './components/JeweleryDetails';
import UpdateJewelry from './components/UpdateJewelry'; // Import the new component
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute'; // Import the PrivateRoute component
import Signup from './components/SignUp';
import Contact from './components/Contact';
import About from './components/About';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import Display from './components/Display';

function App() {
  const [jewelry, setJewelry] = useState([]);

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <ToastContainer />
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Display/>} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route element={<PrivateRoute />}>
              <Route path="/home" element={<Home jewelry={jewelry} setJewelry={setJewelry} />} />
              <Route path="/details/:id" element={<JewelryDetails jewelry={jewelry} />} />
              <Route path="/contact" element={<Contact/>} />
              <Route path="/about" element={<About/>} />
              <Route path="/terms" element={<Terms/>} />
              <Route path="/privacy" element={<Privacy/>} />
              <Route path="/update/:id" element={<UpdateJewelry />} />
            </Route>
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
